import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import { ImageCaptureAccount } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";

export const fetchImageCaptureAccounts = async (): Promise<
  CollectionResponse<ImageCaptureAccount>
> =>
  axiosInstance
    .get(`/admin/image-captures/accounts`)
    .then((response) => response.data);

export const fetchImageCaptureAccountById = async (
  id: string,
): Promise<ImageCaptureAccount> =>
  axiosInstance
    .get(`/admin/image-captures/accounts/${id}`)
    .then((response) => response.data);

export const createImageCaptureAccount = async (
  data: ImageCaptureAccount,
): Promise<null> =>
  axiosInstance
    .post(`/admin/image-captures/accounts`, data)
    .then((response) => response.data);

export const updateImageCaptureAccountById = async (
  id: string,
  data: ImageCaptureAccount,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/image-captures/accounts/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteImageCaptureAccountById = async (
  id: string,
): Promise<null> =>
  axiosInstance
    .delete(`/admin/image-captures/accounts/${id}`)
    .then((response) => response.data);
